import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

import { Modal } from 'ggApp/modules/modal/components/v3';

export const MODAL_CONTENT_CLASS_NAME = 'checkoutModalContent';
export const MODAL_CONTAINER_CLASS_NAME = 'checkoutModalContainer';


export const ModalCheckout = styled(Modal).attrs({
    classNames: {
        content: MODAL_CONTENT_CLASS_NAME,
        container: MODAL_CONTAINER_CLASS_NAME,
    },
})`
    & .${MODAL_CONTAINER_CLASS_NAME} {
        min-height: 30vh;
        height: ${({ height }) => height};
        max-height: 100%;

        ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMax.css`
            height: fit-content;
            max-height: 80vh;
        `};
    }

    & .${MODAL_CONTENT_CLASS_NAME} {
        padding: 0;
        display: flex;
    }
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    z-index: 1;
    right: ${({ theme }) => theme.spacers.L};
    top: ${({ theme }) => theme.spacers.XL};
    cursor: pointer;
`;

export const Container = styled.div`
    width: 100%;
    height: initial;
    padding-top: ${({ showProgress }) => showProgress ? '' : '8px'};
`;

export const CloseButton = styled(ButtonV2)`
    padding: 0px;
`;
